module.exports = __webpack_public_path__ + "img/small.63387c0d.jpg";